const config = {
    API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api', // Fallback to localhost if REACT_APP_API_URL is undefined
    MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000', // Fallback to localhost if REACT_APP_API_URL is undefined
    // API_BASE_URL: process.env.REACT_APP_API_URL || 'https://eventsawa.co.ke/api', // Fallback to localhost if REACT_APP_API_URL is undefined
    // MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_URL || 'https://eventsawa.co.ke', // Fallback to localhost if REACT_APP_API_URL is undefined    // 
};

export default config;
